/* eslint-disable */
import { PieChart, Circle, Settings } from 'react-feather';

// Check if settingPassword exists in localStorage
const settingPassword = localStorage.getItem('settingPassword');
//const butonStatus = localStorage.getItem('isPasswordEntered');
const butonStatus = JSON.parse(localStorage.getItem("isPasswordEntered"));
const isDayendStatus = butonStatus
console.log(typeof isDayendStatus, isDayendStatus, 'isDayendStatus')

// Define the settings items
const settingsItems = [
  {
    id: 'product',
    title: 'Product',
    icon: <Circle size={12} />,
    navLink: '/settings/product'
  },
  {
    id: 'tank',
    title: 'Tank',
    icon: <Circle size={12} />,
    navLink: '/settings/tank'
  },
  {
    id: 'meter',
    title: 'Meter',
    icon: <Circle size={12} />,
    navLink: '/settings/meter'
  },
  {
    id: 'nozzel',
    title: 'Nozzel',
    icon: <Circle size={12} />,
    navLink: '/settings/nozzel'
  },
  {
    id: 'oil',
    title: 'Oil',
    icon: <Circle size={12} />,
    navLink: '/settings/oil'
  },
  {
    id: 'ledger',
    title: 'Ledger',
    icon: <Circle size={12} />,
    navLink: '/settings/ledger'
  },
  {
    id: 'petrocard',
    title: 'PetroCard',
    icon: <Circle size={12} />,
    navLink: '/settings/petrocard'
  },
  {
    id: 'swipe',
    title: 'Swipe',
    icon: <Circle size={12} />,
    navLink: '/settings/swipe'
  },
  {
    id: 'openingCash',
    title: 'Opening Cash',
    icon: <Circle size={12} />,
    navLink: '/settings/openingCash'
  },
  {
    id: 'vehicle',
    title: 'Vehicle',
    icon: <Circle size={12} />,
    navLink: '/settings/vehicle'
  },
  {
    id: 'shift',
    title: 'Select Shift',
    icon: <Circle size={12} />,
    navLink: '/settings/shift'
  },
  {
    id: 'dsmPassword',
    title: 'DSM Password',
    icon: <Circle size={12} />,
    navLink: '/settings/dsmPassword'
  },
  {
    id: 'assignDsmNozzle',
    title: 'Assign DSM Nozzle',
    icon: <Circle size={12} />,
    navLink: '/settings/assignDSMNozzle'
  },
];

// Define the export array conditionally
const menuItems = [
  {
    header: 'Settings'
  },
  (!isDayendStatus || settingPassword)
    ? {
        id: 'setting',
        title: 'Settings',
        badge: 'light-danger',
        // badgeText: '3',
        icon: <Settings size={20} />,
        children: settingsItems,
      }
    : {
        id: 'settingPass',
        title: 'Setting Pass',
        icon: <Settings size={12} />,
        navLink: '/settingPass'
      }
];

export default menuItems;
